<template>
  <div class="profile">
    <c-loader v-if="loading" :active="true" :height="450" label="Анкета загружается" />

    <template v-else>
      <profile-view
        v-if="profile"
        :user-id="userId"
        :profile="profile"
        :profile-data="profileData"
        :editable="editable"
      />
      <positions-view v-else-if="positions" :positions="positions" @update="getData" />
      <div v-else class="no-profile">
        <div class="mb-4 text">Анкеты для этой должности еще не создано</div>

        <c-button color="primary" label="Новая анкета" @click="createProfile" />
      </div>
    </template>

    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import TopButton from "@/components/top-button";
import CLoader from "@/components/loader";
import CButton from "@/components/controls2/Button";

import { userPermissionsList } from "@/constants/userPermissions";

import ProfileView from "./views/ProfileView";
import PositionsView from "./views/PositionsView";
import { ProfileModel } from "./models/Profile";

export default {
  name: "personal-employee-profile",
  components: { TopButton, CLoader, ProfileView, PositionsView, CButton },

  props: ["userInfo"],

  data() {
    return {
      loading: false,
      profile: null,
      profileData: null,
      positions: null,
    };
  },

  computed: {
    userId() {
      return this.$route.params.id;
    },
    editable() {
      const permissions = this.$store.getters.getUserPermissions;
      return permissions.includes(userPermissionsList.worker.profile.edit);
    },
  },

  created() {
    this.getData();
  },

  methods: {
    loadProfile() {
      return this.$store.dispatch("personalEmployee/getUserProfile", this.userId);
    },
    loadProfilePositions() {
      return this.$store
        .dispatch("personalEmployee/getUserProfilePositions", this.userId)
        .then((data) => Object.entries(data).map(([value, label]) => ({ value, label })));
    },
    async getData() {
      this.loading = true;

      this.profile = null;
      this.positions = null;

      const profileData = await this.loadProfile();

      if (profileData) {
        const { id, error } = profileData;

        if (error) {
          if (error === "not_selected") {
            this.positions = await this.loadProfilePositions();
          }
        } else if (id) {
          this.profile = ProfileModel(profileData);
        }
      }

      this.loading = false;
    },
    createProfile() {
      const posts = this.userInfo.postCodes.join(",");
      window.open(`/index.php?r=redesign#/profiles/create?posts=${posts}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.profile {
  margin-top: 43px;

  @include mobileAndTablet {
    padding-bottom: 60px;
  }

  @include onlyMobile {
    padding-bottom: 40px;
  }

  @include beforeBootstrapMd {
    .no-profile {
      .text {
        text-align: center;
      }
      /deep/ {
        .c-button {
          width: 100%;
        }
      }
    }

    /deep/ .scroll-top-button {
      bottom: 85px;
    }
  }
}
</style>
